// extracted by mini-css-extract-plugin
export default {"root":"cookie-consent-footer_root__LpGJv","button":"cookie-consent-footer_button__5MpTl"};